import React from "react";
import { isObjectAllNull } from "../../../services";
import styles from "./style.scss";

const SummaryBar = ({ summary }) => (
  <div className={styles.summary}>
    {isObjectAllNull(summary) ? (
      <span className={styles.info}>
        <span className={styles.value}></span>
      </span>
    ) : (
      <span>
        {summary.map((info: any, index: any) => (
          <span // eslint-disable-next-line
            key={index}
            className={styles.info}
          >
            <span className={styles.value} title={info}>
              {" "}
              {info}
            </span>
            {index < summary.length - 1 && <span className={styles.dot} />}
          </span>
        ))}
      </span>
    )}
  </div>
);

export default SummaryBar;



// WEBPACK FOOTER //
// ./src/components/SimilarAdCard/SummaryBar/index.tsx